import React from 'react';


class ErrorBouncer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            code:null,
            message:''
        };
    }

    static getDerivedStateFromError(error) {
        if (error) {
            return { 
                hasError: true,
                code:error.code,
                message:error.message
            };
        }
    }

    getMessageError = () =>{
        const {code,message} = this.state;
        switch (code){
        case 'CHECK_ROLE':
            return message;
        default:
            return 'Chúng tôi rất tiếc về sự cố này. Vui lòng thử lại hoặc liên hệ chúng tôi để được hỗ trợ';
        }
    }

    render() {
        if (this.state.hasError || this.props.hasError) {
            return (
                <div className="login-container">
                    <div className="login-banner"/>
                    <div className="login-content" style={{justifyContent: 'flex-start'}}>
                        <h2>Đã có lỗi xảy ra</h2>
                        <p>{this.getMessageError()}</p>

                        {
                            !this.props.hideAction &&
                            <a href="/">Quay lại màn hình chính</a>
                        }
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBouncer;